import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {getAllUsers, clearPermistions} from '../redux/actions/usersActions';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import Common from '../components/Common';
import PermistionsUser from '../components/Manager/Staffs/PermistionsUser';
import StaffLists from '../components/Manager/Staffs/StaffLists';
import SentSuccessfully from '../util/SentSuccessfully';

const styles = theme => ({
    ...theme,
    search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#222',
    '&:hover': {
        backgroundColor: '#333',
    },
    width: '100%',
    maxWidth: 960,
    margin: '15px auto 0',
    },
    searchIcon: {
    width: theme.spacing.unit * 9,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    },
    inputRoot: {
    color: 'inherit',
    width: '100%',
    },
    inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
        width: 200,
    },
    },
  })

class Staffs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            filterName: '',
            boxAdd: false,
        }
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
  
    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: event.target.value });
    };
  
    componentDidMount() {
      this.props.getAllUsers();
    }
  
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    };
    clearMessage = () => {
        this.props.clearPermistions();
    }
    render() {
        const { rowsPerPage, page, boxAdd, filterName} = this.state;
        const { classes, users: {loading}, permistions: {message, error} } = this.props;
        var users = this.props.users.users;
        users = users.filter(user => {return user.articlesManager}).length > 0 ?  users.filter(element => element.articlesManager.some(e => e === 'ntea.vn')) : [];
        if(filterName) {
            users = users.filter((user) => {
                return user.fullname.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
            });
        }
        return (
            <Fragment>
                <Common isStaffs={true} toggleleBoxAdd={() => this.setState({boxAdd: !boxAdd})} />
                {message && <SentSuccessfully message={message} clearMessage={() => this.clearMessage()} />}
                {error && <SentSuccessfully error={error} clearMessage={() => this.clearMessage()} />}
                <div className={classes.search}>
                    <div className={classes.searchIcon}>
                        <SearchIcon />
                    </div>
                    <InputBase
                        name="filterName"
                        placeholder="Tìm nhân sự"
                        classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                        }}
                        value={filterName}
                        onChange={this.handleChange}
                    />
                </div>
                {boxAdd &&
                    <PermistionsUser users={this.props.users.users} />
                }
                <div className="box-staffs" >
                {
                    loading ?
                    <div className="box-skeleton"><div /><div /><div /><div /><div /></div>
                    :
                    users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, index) => (
                        <StaffLists user={user} key={index} />
                    ))
                }
                </div>
                {users.length > rowsPerPage &&
                <div className="alignCenter">
                    <button className="btn btn-primary-outline" onClick={() => this.setState({rowsPerPage: this.state.rowsPerPage+10})}>Xem thêm</button>
                </div>
                }
            </Fragment>
        )
    }
}

Staffs.propTypes = {
    getAllUsers: PropTypes.func.isRequired,
    clearPermistions: PropTypes.func.isRequired,
    users: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    users: state.users,
    permistions: state.permistions,
})

export default connect(mapStateToProps, { getAllUsers, clearPermistions })(withStyles(styles)(Staffs));
